export default "__VITE_ASSET__$vimBMQC__"